export default __webpack_public_path__ + "static/media/repo.6d496322.svg";